import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const iniciativapdet = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/iniciativapdet`,
    state: {
        pilaresconruta: [],
        pilares: [],
        iniciativas: []
    }

}).get({
    action: "get_iniciativasbypilaresconruta",
    path: function (obj) {
        return `/groupbypilaresconruta/${obj.idsubregion}`;
    },
    onSuccess: (state, payload) => {
        state.pilaresconruta = payload.data;
    }
}).get({
    action: "get_iniciativasbyregion",
    path: function (obj) {
        return `/listabyregion/${obj.idsubregion}`;
    },
    onSuccess: (state, payload) => {
        state.iniciativas = payload.data;
    }
}).getStore();

iniciativapdet.getters = {
    giniciativasbypilaresconruta: state => {
        return state.pilaresconruta
    },
    giniciativasbyregion: state => {
        return state.iniciativas
    }
}
export default iniciativapdet;
